export const GET_LATEST_SO_CART_START = 'GET_LATEST_SO_CART_START';

export const GET_LATEST_SO_CART_SUCCESS = 'GET_LATEST_SO_CART_SUCCESS';

export const GET_LATEST_SO_CART_FAILURE = 'GET_LATEST_SO_CART_FAILURE';
